import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@clerk/react';

/**
 * Wraps routes that require authentication.
 * Redirects unauthenticated users to /signin; renders Outlet otherwise.
 * Returns null while Clerk is still loading to prevent a redirect flash.
 */
export function ProtectedRoute() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) return null;
  if (!isSignedIn) return <Navigate to="/signin" replace />;

  return <Outlet />;
}
